import { FC } from "react";
import { Form } from "antd";
import ReactQuillCustomJP from "@lhd/components/ReactQuillCustomJP";

const LabelSetting: FC = () => {
  return (
    <Form.Item name="name">
      <ReactQuillCustomJP />
    </Form.Item>
  );
};

export default LabelSetting;
